import "../assets/Terms.css";
import { h as j, defineComponent as G, computed as p, ref as J, openBlock as n, createElementBlock as s, Fragment as U, renderList as V, createVNode as y, toDisplayString as i, createElementVNode as E, unref as C, createCommentVNode as v } from "vue";
import { T as Q, c as f } from "./maps.DxC18PqJ.js";
import { s as F, t as P } from "./useModal.CgbJKM9V.js";
import { n as W, l as X } from "./useStore.CDG6wbfK.js";
import { _ as x } from "./Checkbox.vue_vue_type_style_index_0_lang.w_4wTui5.js";
const A = (b, w) => {
  const t = "http://www.w3.org/2000/svg", u = new DOMParser().parseFromString(`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
  <path fill-rule="evenodd" d="M5.917 5.833a.75.75 0 01.75-.75h7.5a.75.75 0 01.75.75v7.5a.75.75 0 01-1.5 0V7.644l-7.053 7.053a.75.75 0 11-1.061-1.06l7.053-7.054h-5.69a.75.75 0 01-.75-.75z" clip-rule="evenodd"/>
</svg>
`, "image/svg+xml").firstChild;
  if (b.title) {
    const m = document.createElementNS(t, "title");
    m.textContent = b.title, u.appendChild(m);
  }
  const d = Array.from((u == null ? void 0 : u.attributes) ?? []).reduce((m, _) => ({
    ...m,
    [_.name]: _.value
  }));
  return j(
    "svg",
    {
      ...d,
      ...w.attrs,
      role: "img",
      innerHTML: u.innerHTML
    }
  );
}, Z = { class: "thn--tool-terms" }, R = { key: 0 }, ee = {
  key: 0,
  class: "thn--tool-terms__label"
}, te = ["href"], le = ["onMousedown"], ne = {
  key: 4,
  class: "thn--tool-terms__label thn--tool-terms__label--tag"
}, se = {
  key: 0,
  class: "thn--tool-terms__label"
}, oe = ["innerHTML"], re = ["href", "target"], ae = ["onMousedown"], ie = {
  key: 5,
  class: "thn--tool-terms__label thn--tool-terms__label--tag"
}, ge = /* @__PURE__ */ G({
  __name: "Terms",
  props: {
    customTerms: {},
    propertyTerms: {},
    termsInherited: { type: Boolean },
    termsRequired: { type: Boolean },
    disabled: { type: Boolean },
    appearanceStyle: {}
  },
  setup(b, { expose: w }) {
    const t = W(), T = b, u = p(() => {
      const e = (T.propertyTerms ?? []).map((l) => l.id);
      return (T.customTerms ?? []).filter((l) => !T.termsInherited || !e.includes(l.termId));
    }), d = J([]), m = p(
      () => {
        var e;
        return ((e = t == null ? void 0 : t.styles.fonts.formFieldName) == null ? void 0 : e.textTransform) === Q.Titlecase;
      }
    ), _ = p(() => t == null ? void 0 : t.literals.getLiteral("You must agree to the Terms & Conditions first")), L = t == null ? void 0 : t.literals.getLiteral("(Optional)"), M = p(() => t == null ? void 0 : t.literals.getLiteral("Terms_default_label", m.value)), O = p(() => t == null ? void 0 : t.literals.getLiteral("Terms_default"));
    function z() {
      const e = {
        valid: d.value.every((l) => l == null ? void 0 : l.validate()),
        terms: []
      };
      return e.valid && (e.terms = d.value.map((l) => ({
        termId: l.id,
        isChecked: l.isChecked
      }))), e;
    }
    function c(e) {
      var l, a;
      return e.content.languages ? m.value ? X(((l = e.content.languages[(t == null ? void 0 : t.literals.language) || "en"]) == null ? void 0 : l.label) || "") : (a = e.content.languages[(t == null ? void 0 : t.literals.language) || "en"]) == null ? void 0 : a.label : "";
    }
    function K(e) {
      var l, a;
      return (a = (l = e.content.languages) == null ? void 0 : l[(t == null ? void 0 : t.literals.language) || "en"]) == null ? void 0 : a.text;
    }
    function I(e) {
      var l, a;
      return (a = (l = e.content.languages) == null ? void 0 : l[(t == null ? void 0 : t.literals.language) || "en"]) == null ? void 0 : a.url;
    }
    function N(e) {
      return e.content.linkedTo === f.NotLinked;
    }
    function $(e) {
      return e.content.linkedTo === f.Url;
    }
    function Y(e) {
      return e.content.linkedTo === f.CustomUrl;
    }
    function q(e) {
      return [f.CustomText].includes(e.content.linkedTo);
    }
    function B(e) {
      return [f.DefaultText].includes(e.content.linkedTo);
    }
    function D(e) {
      F(K(e) || ""), P();
    }
    function S() {
      F(O.value || ""), P();
    }
    return w({
      validate: z
    }), (e, l) => {
      var a;
      return n(), s("div", Z, [
        e.termsInherited && ((a = e.propertyTerms) != null && a.length) ? (n(), s("div", R, [
          (n(!0), s(U, null, V(e.propertyTerms, (r, h) => (n(), s("div", {
            class: "thn--tool-terms__item",
            key: h
          }, [
            y(x, {
              ref_for: !0,
              ref: (o) => d.value[h] = o,
              "error-message": _.value,
              class: "thn--tool-terms__checkbox",
              disabled: !!e.disabled,
              required: e.termsRequired,
              name: "terms-inherit",
              id: r.id
            }, null, 8, ["error-message", "disabled", "required", "id"]),
            N(r) ? (n(), s("div", ee, i(c(r)), 1)) : $(r) ? (n(), s("a", {
              key: 1,
              class: "thn--tool-terms__label thn--tool-terms__label--url",
              href: I(r),
              target: "terms-inherit"
            }, [
              E("span", null, i(c(r)), 1),
              y(C(A), { class: "thn--tool-terms__label--icon" })
            ], 8, te)) : q(r) ? (n(), s("div", {
              key: 2,
              class: "thn--tool-terms__label thn--tool-terms__label--popup",
              onMousedown: (o) => D(r)
            }, i(c(r)), 41, le)) : B(r) ? (n(), s("div", {
              key: 3,
              class: "thn--tool-terms__label thn--tool-terms__label--popup",
              onMousedown: l[0] || (l[0] = (o) => S())
            }, i(M.value), 33)) : v("", !0),
            e.termsRequired ? v("", !0) : (n(), s("div", ne, i(C(L)), 1))
          ]))), 128))
        ])) : v("", !0),
        (n(!0), s(U, null, V(u.value, ({
          termId: r,
          isRequired: h,
          term: o
        }, g) => (n(), s("div", {
          class: "thn--tool-terms__item",
          key: g
        }, [
          y(x, {
            ref_for: !0,
            ref: (k) => {
              var H;
              return e.termsInherited && ((H = e.propertyTerms) != null && H.length) ? d.value[g + e.propertyTerms.length] = k : d.value[g] = k;
            },
            "error-message": _.value,
            class: "thn--tool-terms__checkbox",
            disabled: !!e.disabled,
            required: h,
            name: `terms-${g}`,
            id: r
          }, null, 8, ["error-message", "disabled", "required", "name", "id"]),
          N(o) ? (n(), s("div", se, i(c(o)), 1)) : Y(o) ? (n(), s("div", {
            key: 1,
            class: "thn--tool-terms__label thn--tool-terms__label--custom",
            innerHTML: o.content.htmlContent
          }, null, 8, oe)) : $(o) ? (n(), s("a", {
            key: 2,
            class: "thn--tool-terms__label thn--tool-terms__label--url",
            href: I(o),
            target: `terms-${g}`
          }, [
            E("span", null, i(c(o)), 1),
            y(C(A), { class: "thn--tool-terms__label--icon" })
          ], 8, re)) : q(o) ? (n(), s("div", {
            key: 3,
            class: "thn--tool-terms__label thn--tool-terms__label--popup",
            onMousedown: (k) => D(o)
          }, i(c(o)), 41, ae)) : B(o) ? (n(), s("div", {
            key: 4,
            class: "thn--tool-terms__label thn--tool-terms__label--popup",
            onMousedown: l[1] || (l[1] = (k) => S())
          }, i(M.value), 33)) : v("", !0),
          h ? v("", !0) : (n(), s("div", ie, i(C(L)), 1))
        ]))), 128))
      ]);
    };
  }
});
export {
  ge as _
};
//# sourceMappingURL=Terms.vue_vue_type_style_index_0_lang.DvSwaGI1.js.map
